import request from '../utils/request.js'

export default {
  getList (params) {
    return request.post(`kaochang/lists`, params).then(res => res.data)
  },
  add (params) {
    return request.post(`kaochang/add`, params).then(res => res.data)
  },
  edit (params) {
    return request.post(`kaochang/add`, params).then(res => res.data)
  },
  details (params) {
    return request.post(`kaochang/details`, params).then(res => res.data)
  },
  delete (params) {
    return request.post(`kaochang/del`, params).then(res => res.data)
  },
  selectList (params) {
    return request.post(`kaochang/selectlist`, params).then(res => res.data)
  },
  mentie (params) {
    return request.post(`kaochang/export_mentie`, params).then(res => res.data)
  },
  qiandaobiao (params) {
    return request.post(`kaochang/export_sign`, params).then(res => res.data)
  }

}



// WEBPACK FOOTER //
// ./src/api/kaochang.js